import React, { useEffect } from "react";
import styles from "./styles.module.css";
import AnimatedNudge from "../AnimatedNudge";
import { getWidth } from "../../../utils/relativeSizes";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { GAMEPLAY_ANIMATION_IMAGES } from "../../../assets";
import { useTranslation } from "react-i18next";
import { getShowExtraMoveNudge } from "../../../store/selectors/ludoboardSelectors";
// import { playStartSoundOfGame } from "classes/voiceovers/GameSoundManager";

// const _playStartSound = () => {
//   playStartSoundOfGame();
// };

function ExtraMoveAnimation() {
  const { t } = useTranslation();
  const showExtraMoveNudge = useSelector(getShowExtraMoveNudge);

  useEffect(() => {
    if (showExtraMoveNudge) {
      // setTimeout(_playStartSound, 500);
    }
  }, [showExtraMoveNudge]);

  if (!showExtraMoveNudge) {
    return null;
  }

  return (
    <AnimatedNudge>
      <div 
        className={clsx(styles.wrapper, "hexagonShapeWrapper")}
        style={{ 
          backgroundImage: `url(${GAMEPLAY_ANIMATION_IMAGES.hexagonShape})`, 
          width: getWidth(110), 
          height: getWidth(72)
        }}
      >
        <div className={clsx(styles.text, "hexagonShapeText fontSizeSm14 fontWeight800 textUppercase fontColorDarkBlue2 flex alignItemCenter justifyContentCenter relative")}>{t("extraMove")}</div>
      </div>
    </AnimatedNudge>
  );
}

export default ExtraMoveAnimation;
